// @flow

import * as React from 'react';
import {ContentGroupItem} from 'docs/util';
import {renderMarkdocAsReact} from 'docs/markdoc';
import {TabGroup} from '../Tabs/TabGroup';

type BeforeAfterTableGroupProps = {|
  items: Array<ContentGroupItem>,
  pref?: string,
|};

export const BeforeAfterTableGroup = (props: BeforeAfterTableGroupProps) => {
  return (
    <TabGroup
      selector="tabs"
      {...props}
      items={props.items.map(
        (item) =>
          new ContentGroupItem(
            item.id,
            item.title,
            renderMarkdocAsReact(item.content),
          ),
      )}
    />
  );
};
